import { render, staticRenderFns } from "./waterSankey.vue?vue&type=template&id=4c0a1165&scoped=true"
import script from "./waterSankey.vue?vue&type=script&lang=js"
export * from "./waterSankey.vue?vue&type=script&lang=js"
import style0 from "./waterSankey.vue?vue&type=style&index=0&id=4c0a1165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a1165",
  null
  
)

export default component.exports